// opportunitySignalsAnalytics.js — BL-011 Operational Intelligence (item 7)
//
// Thin, declarative wrappers over lib/analytics.track for the Opportunity
// Signals dashboard panel. Centralizing the event names here keeps call sites
// clean and locks the contract under test. track() already injects the BL-025
// `environment` super-property/tag, so these events are environment-safe.
//
// PII-safe (ADR-040): only counts/flags — never a market label, user id, or
// raw signal payload.

import { track } from './analytics';

// Panel rendered with (or without) market signals. `market_count` drives the
// derived `has_signals` flag so the Metric Registry (M-004) can compute both
// engagement and data-availability from a single event.
export function opportunitySignalsViewed({ market_count = 0, ...rest } = {}) {
  track('opportunity_signals_viewed', {
    market_count,
    has_signals: market_count > 0,
    ...rest,
  });
}

// Panel rendered in its empty-state ("not enough activity yet") — a real
// product signal that a caller's markets lack servable, k-anonymous data.
export function opportunitySignalsEmpty(props = {}) {
  track('opportunity_signals_empty', props);
}
